import { Country } from '@afterpay/types'
import { AllCountryCode } from '@afterpaytouch/core'

export const highRiskCountries = {
  AU: ['KP', 'IR', 'SY', 'CU', 'UA', 'ID', 'PL', 'AE', 'SA', 'VU', 'BD', 'HU', 'MO', 'MK', 'IR'],
  NZ: ['KP', 'IR', 'SY', 'CU', 'UA', 'ID', 'PL', 'AE', 'SA', 'VU', 'BD', 'HU', 'MO', 'MK', 'IR'],
  GB: [
    'AF',
    'DZ',
    'AO',
    'KH',
    'KY',
    'CN',
    'CU',
    'CI',
    'HT',
    'IR',
    'KE',
    'KP',
    'LA',
    'MZ',
    'MM',
    'NI',
    'NG',
    'SN',
    'SL',
    'SY',
    'UA',
    'VE',
    'VN',
    'YE',
    'BS',
    'BB',
    'BO',
    'BA',
    'BW',
    'BF',
    'GH',
    'JM',
    'KG',
    'LR',
    'MU',
    'MN',
    'PK',
    'PA',
    'PY',
    'LK',
    'TJ',
    'TZ',
    'TH',
    'TT',
    'VU',
    'ZW',
  ],
  DEFAULT: [],
}

export const filterHighRiskCountries =
  (consumerCountry: Country) =>
  (supportedCountryList: AllCountryCode[]): AllCountryCode[] => {
    if (typeof supportedCountryList === 'undefined' || supportedCountryList?.length === 0) {
      return []
    }

    const filteredCountryList = supportedCountryList.filter((country) => {
      const highRiskCountryList = highRiskCountries[consumerCountry] ?? highRiskCountries.DEFAULT
      return !highRiskCountryList.includes(country)
    })

    return filteredCountryList
  }
